export const BILLING_INTERVALS = {
  MONTH: 'month',
  YEAR: 'year',
};

export const BILLING_PRODUCT_TYPES = {
  BASE: 'base',
  TRIAL: 'trial',
};

/** UI + entitlements (app source of truth). Prices come from Stripe via list-plans (STRIPE_CATALOG_SECRET_KEY). */
export const BILLING_CATALOG = [
  {
    id: 'essential',
    name: 'SmartWatcher Essential',
    type: BILLING_PRODUCT_TYPES.BASE,
    recommended: false,
    description: 'LinkedIn Smart Watch for your candidate pipeline with core monitoring and alerts.',
    lookupKeys: {
      month: 'smart_watch_essential_monthly',
      year: 'smart_watch_essential_yearly',
    },
    features: [
      'LinkedIn profile monitoring',
      'Activity alerts',
      'Candidate pipeline dashboard',
      'CSV import',
    ],
  },
  {
    id: 'pro',
    name: 'SmartWatcher Pro',
    type: BILLING_PRODUCT_TYPES.BASE,
    recommended: false,
    description: 'Everything in Essential plus ATS integration and higher monitoring limits.',
    lookupKeys: {
      month: 'smart_watch_pro_monthly',
      year: 'smart_watch_pro_yearly',
    },
    features: [
      'Everything in Essential',
      'ATS integration',
      'Higher candidate limits',
      'Priority monitoring',
    ],
  },
  {
    id: 'essential-and-voice',
    name: 'SmartWatcher Essential + Voice AI',
    type: BILLING_PRODUCT_TYPES.BASE,
    recommended: false,
    description: 'Essential SmartWatcher monitoring bundled with AI voice triage for candidate calls.',
    lookupKeys: {
      month: 'smart_watch_essential_and_voice_monthly',
      year: 'smart_watch_essential_and_voice_yearly',
    },
    features: [
      'Everything in Essential',
      'AI voice outreach',
      'Call summaries',
      'Monthly AI call minutes',
    ],
  },
  {
    id: 'pro-and-voice',
    name: 'SmartWatcher Pro + Voice AI',
    type: BILLING_PRODUCT_TYPES.BASE,
    recommended: true,
    description: 'Pro SmartWatcher with ATS integration plus AI voice triage for candidate calls.',
    lookupKeys: {
      month: 'smart_watch_pro_and_voice_monthly',
      year: 'smart_watch_pro_and_voice_yearly',
    },
    features: [
      'Everything in Pro',
      'AI voice outreach',
      'Call summaries',
      'Monthly AI call minutes',
    ],
  },
];

/** 3-day trial — separate from the main plan grid. Price from Stripe via list-plans. */
export const BILLING_TRIAL = {
  id: 'trial-pro-and-voice',
  subscriptionPlanId: 'trial',
  name: 'SmartWatcher Pro + Voice AI Trial',
  type: BILLING_PRODUCT_TYPES.TRIAL,
  lookupKey: 'trial_smart_watch_pro_and_voice',
  durationDays: 3,
  includesPlanName: 'SmartWatcher Pro + Voice AI',
};

export const BASE_PRODUCT_IDS = BILLING_CATALOG
  .filter((product) => product.type === BILLING_PRODUCT_TYPES.BASE)
  .map((product) => product.id);

/** One-time add-on packs of extra AI call minutes (Voice AI plans only). Price from Stripe via list-plans. */
export const BILLING_EXTRA_MINUTES = [
  { id: 'extra_minutes_100', minutes: 100, name: '100 extra minutes', lookupKey: 'extra_minutes_100' },
  { id: 'extra_minutes_500', minutes: 500, name: '500 extra minutes', lookupKey: 'extra_minutes_500' },
  { id: 'extra_minutes_1000', minutes: 1000, name: '1000 extra minutes', lookupKey: 'extra_minutes_1000' },
];

export const EXTRA_MINUTES_PRODUCT_IDS = BILLING_EXTRA_MINUTES.map((product) => product.id);
